export const COLOR = "#F7AD2A";
export const ALE_COLOR = "#36080A";
export const OUTLINE_WIDTH = 1;